import { ThemeAPI } from '@ingestro/importer-react'

// See reviewEntries.ts for explanation on why we use f0 CSS custom properties directly.
// Nuvo shows a shared grey popover (root) when a cell has multiple annotations,
// with a colored circle icon per annotation level. When a cell has a single annotation,
// the popover uses the level-specific root style instead.
export const popover: ThemeAPI['popover'] = {
  // Multi-annotation container: grey background with white text
  root: {
    color: 'hsl(var(--white-100))', // f1-foreground-inverse
    backgroundColor: 'hsl(var(--neutral-solid-50))',
    borderColor: 'hsl(var(--neutral-solid-50))',
  },
  // Single-annotation: colored background per level. Circle: for multi-annotation colored dot.
  info: {
    root: {
      color: 'hsl(var(--white-100))', // f1-foreground-inverse
      backgroundColor: 'hsl(var(--info-50))', // f1-background-info-bold
      borderColor: 'hsl(var(--info-50))', // f1-border-info-bold
    },
    circle: {
      backgroundColor: 'hsl(var(--info-50))', // f1-background-info-bold
    },
  },
  warning: {
    root: {
      color: 'hsl(var(--white-100))', // f1-foreground-inverse
      backgroundColor: 'hsl(var(--warning-50))', // f1-background-warning-bold
      borderColor: 'hsl(var(--warning-50))', // f1-border-warning-bold
    },
    circle: {
      backgroundColor: 'hsl(var(--warning-50))', // f1-background-warning-bold
    },
  },
  error: {
    root: {
      color: 'hsl(var(--white-100))', // f1-foreground-inverse
      backgroundColor: 'hsl(var(--critical-50))', // f1-background-critical-bold
      borderColor: 'hsl(var(--critical-50))', // f1-border-critical-bold
    },
    circle: {
      backgroundColor: 'hsl(var(--critical-50))', // f1-background-critical-bold
    },
  },
}
